
import {from as observableFrom,  Observable } from "rxjs";

import { AfterViewInit, Directive, Input } from "@angular/core";
import { Router } from "@angular/router";
import { filter, take } from "rxjs/operators";
import { CommonFormManagerDirective } from "../form-manager.directive";

@Directive({
    selector: "[changeRouteOnFormClose]",
    exportAs: "ChangeRouteOnFormClose",
})
export class ChangeRouteOnFormCloseDirective implements AfterViewInit {
    @Input("changeRouteOnClose") public routePath: string[];

    constructor(
        public router: Router,
        public formManager: CommonFormManagerDirective,
    ) { }

    public ngAfterViewInit() {
        observableFrom(this.formManager.formClose$).pipe(
            filter((closed) => !!closed),
            take(1))
            .subscribe(() => {
                this.router.navigate(this.routePath);
            });
    }
}
